import { z } from 'zod';

import { FormField } from './constants';
import type { FormValues } from './types';

export const createDataDisputeValidationSchema = z.object({
  [FormField.reason]: z.string().nonempty('Should enter a reason'),
}) satisfies z.ZodType<FormValues>;
